export default __webpack_public_path__ + "static/media/marauders-map-v2-01-01.5c26298d.jpg";